import { ReactNode } from 'react'
import classnames from 'classnames'
import { CharStatus } from '../../lib/statuses'
import { MAX_WORD_LENGTH, REVEAL_TIME_MS } from '../../constants/settings'
import { getStoredIsHighContrastMode } from '../../lib/localStorage'

type Props = {
  classname?: string
  children?: ReactNode
  value: string
  width?: number
  fontSize?: number
  fontWeight?: number
  status?: CharStatus
  onClick: (value: string) => void
  isRevealing?: boolean
}

export const Key = ({
  classname,
  children,
  status,
  width = 40,
  value,
  fontSize,
  fontWeight,
  onClick,
  isRevealing,
}: Props) => {
  const keyDelayMs = REVEAL_TIME_MS * MAX_WORD_LENGTH
  const isHighContrast = getStoredIsHighContrastMode()

  const classes = classnames(
    ' keycaps flex items-center justify-center rounded mx-0.5 text-lg text-black font-bold cursor-pointer select-none dark:text-white',
    classname,
    {
      'transition ease-in-out': isRevealing,
      'bg-primary-light dark:bg-slate-600 hover:bg-slate-300 active:bg-primary-sdc active:!text-white':
        !status,
      'bg-black dark:bg-slate-800 !text-white': status === 'absent',
      'bg-orange-500 hover:bg-orange-600 active:bg-orange-700 !text-white':
        status === 'correct' && isHighContrast,
      'bg-cyan-500 hover:bg-cyan-600 active:bg-cyan-700 !text-white':
        status === 'present' && isHighContrast,
      'bg-green-500 hover:bg-green-600 active:bg-green-700 !text-white':
        status === 'correct' && !isHighContrast,
      'bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-700 !text-white':
        status === 'present' && !isHighContrast,
    }
  )

  const styles = {
    transitionDelay: isRevealing ? `${keyDelayMs}ms` : 'unset',
    width: `${width}px`,
    height: '48px',
    fontSize: `${fontSize}px`,
    fontWeight: fontWeight,
  }

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    onClick(value)
    event.currentTarget.blur()
  }

  return (
    <button style={styles} className={classes} onClick={handleClick}>
      {children || value}
    </button>
  )
}
